import ClassroomVerificationHeartbeat from './ClassroomVerificationHeartbeat';

export default ClassroomVerificationHeartbeat;
